import React from "react";
import { Popover } from "@headlessui/react";
import { WhatsappLogo } from "phosphor-react";

export const ButtonContact = () => {
  const handleClick = () => {
    const url = `https://wa.me/${'5588981849258'}?text=${encodeURIComponent('Olá Kauê me chamo: ')}`;
    window.location.href = url;
  };

  return (
    <Popover className='tw-fixed tw-bottom-4 tw-right-4 lg:tw-bottom-8 lg:tw-right-8 tw-flex tw-flex-col tw-items-end'>
    <Popover.Button onClick={handleClick} className='tw-bg-[#2E3C50] tw-rounded-full tw-px-3 tw-h-12 tw-text-[#5CFFFF] tw-flex tw-items-center tw-group focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-offset-1 focus:ring-offset-zinc-900 focus:ring-brand-500'>
      <WhatsappLogo className='tw-w-6 tw-h-6' />
      <span className='tw-max-w-0 tw-overflow-hidden group-hover:tw-max-w-xl tw-transition-all tw-duration-500 tw-ease-linear'>
        <span className='tw-pl-2'></span>
        Whatsapp
      </span>
    </Popover.Button>
  </Popover>
  );
};
